import { goalbookUrls } from '@/util/links.js'

export interface DomoEmbed {
  embed_id: string
  name: string
  internal_user_uuids: string[]
  domain_uuids: string[] | null
  created_at: string
  updated_at: string
}

/**
 * Get the Domo proxy URL with embed ID and filters
 * The proxy endpoint handles authentication and PDP backend filtering
 */
export function getDomoProxyUrl(
  embedId: string,
  filters: Record<string, string> = {}
): string {
  const params = new URLSearchParams({
    embed_id: embedId,
    ...filters
  })
  return `${goalbookUrls.pathwaysApi}/analytics/domo/embed/proxy?${params.toString()}`
}

/**
 * Fetch available Domo embeds for the current user
 */
export async function fetchDomoEmbeds(): Promise<DomoEmbed[]> {
  const response = await fetch(`${goalbookUrls.pathwaysApi}/analytics/domo/user_embeds`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch user embeds: ${response.status}`)
  }

  return response.json()
}
